import { ApiGetResponse, ApiRequest } from 'app/common/types'

import { ConnectionEntity } from './connections'

export interface OAuthUser {
  email: string | null
  name: string | null
  timestamp: string | null
}

export type OAuthGetRequest = ApiRequest<object>
export type OAuthGetResponse = ApiGetResponse<ConnectionEntity>

export const isOAuthUser = (user: unknown): user is OAuthUser =>
  !!user &&
  (user as OAuthUser).email !== undefined &&
  (user as OAuthUser).name !== undefined &&
  (user as OAuthUser).timestamp !== undefined
